import React, { useState } from 'react';
import Helmet from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';
import '../assets/styles/base/standard-page.scss';

import Layout from '../components/layout';
import SEO from '../components/seo';
import AnouncementBar from '../components/home/announcement-bar';

const Faq = () => {
  const data = useStaticQuery(
    graphql`
      query {
        faq {
          seo {
            title
            canonical
            description
            og {
              description
              image
              title
              type
              url
            }
          }
        }
        dinggostats {
          averageTimeToQuote
        }
        general {
          email
          phone
        }
      }
    `
  );
  const { general } = data;
  const { seo } = data.faq;
  const { averageTimeToQuote } = data.dinggostats;
  const accordion = [];
  const height = [];
  const faqs = [
    {
      title: 'Can Panel Beaters create quotes from photos?',
      content: 'They sure can. Most external or cosmetic car damage can be quoted off just a few clear images.<br>For our system we just need three photos, which we provide an easy guide for you to follow. Our team at DingGo then check the images before passing on to Panel Beaters to ensure they are good quality and you will get an accurate quote with no surprises. Don’t stress, if there are any issues with the images then we will let you know and work with you to get them right. <br><br>If there is any internal damage (more than just the exterior panels), we suggest taking your car in to a Panel Beater for a thorough inspection. We are still happy to help manage this and link you up with one of our trusted repairers.'
    },
    {
      title: 'How many quotes will I receive?',
      content: 'You can expect to receive up to three quotes. This way you can choose the quote that suits your needs best. All repairers will be local to you so you can just choose your preferred quote based on the best price, the time frame you need, if you need a replacement car or whichever is the highest rated repairer. On average our customers save 32% across the different quoted prices they receive.'
    },
    {
      title: 'How long does it take to receive a quote?',
      content: `On average we return three quotes within ${averageTimeToQuote} hours of submitting your damage to us. This return time is dependent on the response time of our panel beaters and is always a little slower over the weekend.`
    },
    {
      title: 'I have found the perfect quote how do I confirm my appointment?',
      content: 'Simply click, “Book Now” and then you will have the option to select exactly when you would like to have your car repaired. We will take care of the rest and confirm with the panel beater the appointment time as well as sending you a confirmation email so you don’t forget.'
    },
    {
      title: 'What if I decide not to accept any of the quotes?',
      content: 'It’s always your choice if you decide to proceed with one of your repair quotes. We offer our quoting service obligation free. As a courtesy to us and our repairers if you wish to cancel your submission or no longer proceed please let us know by sending us an email at <a class="grey-link text-lb noPad" href="mailto:help@dinggo.com.au">help@DingGo.com.au</a>. Our panel beaters and smash repairers are all legendary humans, so we need your help to please treat them with respect and not leave them wondering.'
    },
    {
      title: 'Is the price quoted the price I will pay?',
      content: 'Absolutely. When you select a quote the price you see for the repair is the exact price you will pay when it’s complete. There are no hidden fees. The only exception is if the panel beater discovers additional damage upon physical inspection that was not visible in the images. If this happens the repairer will always contact you first so there are no surprises. You can then decide if you want to go ahead with the additional required work or not. It’s always up to you!'
    },
    {
      title: 'Does the price quoted include all parts and labour?',
      content: 'Yes. The price you see in our quotes will include all components of the repair including any parts, any paint and labour. '
    },
    {
      title: 'My quotes are very different in price, why is that?',
      content: 'Sometimes the quotes you will receive can vary quite significantly. Most often the reason for this is that some repairers are quoting on repairing the damaged part of your vehicle while others are quoting on replacing the damaged part with a new factory part instead. This is simply a differing in professional opinion on what they think is the right option for the job. A replaced part is guaranteed to look brand new again, but it will usually come at a higher expense.'
    },
    {
      title: 'What are additional services and how do I know what’s included in my quote?',
      content: 'Additional services are the services offered by the panel beater that are beyond the required repair. These are services which provide additional levels of customer service to make the experience as easy for you as possible. These include things like a free loan car, free car pickup, free drop off, free car wash or comfortable waiting rooms with tea and coffee. Each panel beater offers these services at their own discretion, but they can also be requested when you submit if it’s important you have one of them (eg. Loan car). These additional services will always be listed in each of your quotes. Everything listed in the quote is included in the total price on the quote, there are no hidden fees for these.<br><br>If any special requests arise after you have already submitted your damage repair request then don’t worry, just give us send us an email at <a class="grey-link text-lb noPad" href="mailto:help@dinggo.com.au">help@DingGo.com.au</a> and we will do everything we can to help you.'
    },
    {
      title: 'Can I change my repair service date after making a booking?',
      content: 'You sure can, no worries at all, we understand that things can come up. Just send us an email at <a class="grey-link text-lb noPad" href="mailto:help@dinggo.com.au">help@DingGo.com.au</a>  and we’ll happily reschedule your booking for you.'
    },
    {
      title: 'Can repairers come to me?',
      content: 'Yes indeed. We have a network of mobile repairers who specialise in alloy wheel repairs, small paint and scratch repairs and minor dent repairs. These mobile repairers will happily come to your home or office provided those locations have outdoor space for them to work and have access to power and water. When you submit your damage to DingGo you can select an option that includes a request to include mobile repairers in your quotes.'
    },
    {
      title: 'Will my warranty be affected if I book with a Panel Beater on DingGo rather than with the dealership?',
      content: 'Not at all. Certified Panel Beaters and Mobile Repairers are qualified to carry out repairs as per manufacturers specifications without affecting the manufacturer’s Warranty. If your repair requires replacement parts then they will always quote for genuine manufacturers parts, unless you specifically request otherwise or if they specify otherwise in their quote (eg. It’s an older car outside warranty and you are looking for a lower price). Some Panel Beaters even have manufacturer sponsored additional certification, so they are specifically recommended by manufacturers to complete repairs (more common for luxury cars). Any of our repairers with these extra certifications will have them outlined in their DingGo profile page. If you are still uncertain and looking for a recommended repairer for your specific vehicle type, please don’t hesitate to send us an email at <a class="grey-link text-lb noPad" href="mailto:help@dinggo.com.au">help@DingGo.com.au</a>.'
    },
    {
      title: 'Do Panel Beaters on DingGo offer a warranty on their work?',
      content: 'Some panel beaters offer a lifetime warranty or guarantee on their smash repairs, whilst others offer the standard three years warranty on their workmanship instead. It’s important to ensure the warranties you get also extend to any replacement parts that were used as part of the smash repairs. As part of your quote each panel beater will state their warranties on the work and parts offered.'
    },
    {
      title: 'Can I still use DingGo if I want to use my insurance?',
      content: 'Absolutely. Most of our trusted network of Panel Beaters work with the major insurance companies. Just let us know in your submission description if you want to use insurance and the name of your insurer, that way we can pair you with the repairers in our network who are also approved repairers with your insurer. Once you have chosen a repairer you just let the Panel Beater know you want to use insurance and then let them take care of the rest for you. They all have experience in dealing with insurance companies on your behalf and will help save you the hassle.'
    },
    {
      title: 'Is it cheaper to use DingGo instead of claiming my repair through Insurance?',
      content: 'This depends on the extent of the damage to your vehicle. In many cases, particularly with small repairs ($300 to $1,000) it’s more cost effective not to claim your vehicle repair through insurance as the cost of your insurance excess and loss of any no claim bonuses could end up costing you more than simply repairing it privately. <br><br>This is how it works:<br><br><ol><li>All car insurance policies have a payable excess for any claim you make. This is the mandatory contribution you have to make towards the cost of the repair while the insurance company covers the rest of the cost. In most cases your excess will be between $500 to $1000 but can easily be higher depending on your policy. If the vehicle repair costs the same or less than your excess, then it is not worth using insurance as it might end up affecting the price of your future premiums. </li><li>Your premium is the annual amount you pay for the insurance on your vehicle and often includes a ‘no claim bonus’ discount which is dependent on the number of years you have had the policy and not made an insurance claim. If you have this bonus after you make a claim the price of your premium will go up the following year as you will lose your no claim bonus discount. Each policy is different so always check your policy first so that you know your options. Either way you should use DingGo to help you find the best repairers at the best price. Even if you want to use insurance as we can help make the insurance process easier for you.</li></ol>'
    },
    {
      title: 'Am I able to select the Panel Beater of my choice or do I need to use the one my insurance company sends me too?',
      content: 'It depends on your policy.  If you have ‘choice of repairer’ on your policy then you can use whoever you want. Some big insurers like NRMA and AAMI don’t offer choice of repairers as standard and instead you have to use one that they choose. This benefits the insurance company by keeping their costs down, but it does not necessarily mean it’s the best option for you. These workshops might have a long wait time for a repair, not specialise in your vehicle type or be inconveniently located for you. There is also nothing to suggest these workshops are any better or worse than independent repairers. <br><br>Almost all our panel beaters work with the major insurance companies and have experience dealing with these claims on your behalf. So, if you find a repairer and quote you like on DingGo then simply let them know you wish to use insurance and they will take care of the rest for you.'
    },
    {
      title: 'What Can A Mobile Repairer Fix? ',
      content: 'Bumper Repairs: Mobile car repairers can expertly repair bumper scratches, scrapes, scuffs and tears on-site, colour matching the original bumper paint and repairing to manufacturer standards. Even if your bumper has a hole in it or is split, a mobile repairer can usually repair it, using plastic welding equipment. <br><br>Panel Scratches: Car panel key scratches, scrapes, stone chips and minor panel damage are ideal for mobile repair. These common repairs can be fix in 1-3 hours, at your home or work. Even deep scratches that break through to the metal can be repaired by a mobile repairer using a spot repair technique also known as Small to Medium Area Repair Technology repair. In terms of which panels mobile repairers can fix, it’s usually any vertical panel (so not the roof, bonnet or boot). Mobile repairers can usually repair up to four panels on a vehicle. <br><br>Dent Repairs: Small dents to external vertical panels, often made by shopping trolleys, tight garages and other car doors are also regularly repaired by mobile panel beaters. Mobile repairers can fix dents easily and quickly, colour matching to your vehicle’s manufactured colour.  One thing to be careful of with dent repair is that mobile car repairers can’t fix all dents, just small ones. A good rule of thumb is if the dent is larger than a sheet of A4 paper, a mobile repairer might not be your best option. If it’s smaller than an A4 sheet of paper (and not on the roof, bonnet or boot) then a mobile repairer is a cost-effective and convenient option. <br><br>Alloy Wheels: Alloy wheel damage, or rim damage, includes gutter rash, curb damage, and other cosmetic damages, which can happen frequently with city and suburban driving. Mobile repairers fix the alloy wheels by first smoothing back the damaged rim using special machines and then re-coating the alloy wheel with paint colour-matched to the original colour.<br><br>Side Mirrors: Car side mirrors and wing mirrors are prone to scrapes and scuffs as they are often the first point of contact for cars entering tight spaces. The outer casing of the side mirror often gets scraped or scuffed before the driver realises it and corrects their course. Mobile repariers can fix any damage to the casings, including scrapes, scratches and cracks. <br><br>One thing to be careful with side mirror and wing mirror repair is that mobile car repairers can’t fix it if there is any mechanical damage or functional damage to the operation of the mirror. Any damaged technology or mechanisms within the side mirror can’t be repaired- this is a job for panel beater auto repair workshop. '
    }
  ];
  const [showAccordion, setShowAccordion] = useState([]);

  const toggleAccordion = (idx, e) => {
    const parent = e.target.parentNode;
    let accordionBody = parent.getElementsByClassName('accordion-body-inner')[0].offsetHeight;
    let toggle = true;
    if (typeof showAccordion.accordion !== 'undefined') {
      toggle = !showAccordion.accordion[idx];
    }

    accordion[idx] = toggle;
    height[idx] = accordionBody;

    setShowAccordion({
      accordion,
      height
    });
  };

  const addAccordionClass = (idx) => {
    if (showAccordion.accordion) {
      return showAccordion.accordion[idx]
    }

    return false;
  };

  const getInnerHeight = (idx) => {
    if (showAccordion.height) {
      return showAccordion.height[idx]
    }

    return 0;
  };

  const schema = () => {
    const questions = [];
    faqs.map((key, idx) => {
      questions.push({
        "@type": "Question",
        "name": key.title,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": key.content
        }
      })
    });

    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": questions
    }
  };

  return (
    <Layout wrapperClass="standard-page" showSiteIndex={true} hideHeaderFooter={true}>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(schema())}
        </script>
      </Helmet>
      <SEO
        title={seo.title}
        description={seo.title}
        canonical={seo.canonical}
        stucturedData=""
        ogTitle={seo.og.title}
        ogDescription={seo.og.description}
        ogImage={seo.og.image}
        ogType={seo.og.type}
        ogUrl={seo.og.url}
      />
      <AnouncementBar />
      <div className="hero-banner">
        <div className="container">
          <h6>FAQ</h6>
          <h1>We've got answers</h1>
        </div>
      </div>
      <div className="main-wrapper">
        <div className="py-7">
          <div className="container">
            {faqs.map((x, i) => (
              <div className={`accordion ${addAccordionClass(i) ? 'open' : 'closed'}`} key={i}>
                <div className="accordion-title"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleAccordion(i, e);
                  }}>
                  {x.title}
                </div>
                <div className="accordion-body" style={{ height: getInnerHeight(i) }}>
                  <div
                    className="accordion-body-inner"
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                      __html: x.content,
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Layout >
  );
};

export default Faq;
